import C from "./util/net.js";
import ve from "./models/braze-event.js";
import s from "./common/event-logger.js";
import { randomInclusive as U } from "./util/math.js";
import t from "./models/request-result.js";
import {
  logger as r,
  IndexedDBAdapter as A,
  Guid as p,
  EventTypes as i,
} from "../shared-lib/index.js";
import { STORAGE_KEYS as o } from "./managers/storage-manager.js";
import T from "./managers/subscription-manager.js";
import yt from "./Push/utils/push-utils.js";
import D from "./util/request-header-utils.js";
export default class Lt {
  constructor(t, i, s, e, h, o, n, r, u, l) {
    (this.rn = t),
      (this.baseUrl = i),
      (this.ri = s),
      (this.on = e),
      (this.wt = h),
      (this.yt = o),
      (this.u = n),
      (this.wu = r),
      (this.Ko = u),
      (this.qt = l),
      (this.rn = t),
      (this.baseUrl = i),
      (this.yu = 0),
      (this.fE = n.dE() || 0),
      (this.ju = null),
      (this.ri = s),
      (this.on = e),
      (this.wt = h),
      (this.yt = o),
      (this.u = n),
      (this.Ko = u),
      (this.qt = l),
      (this.wu = r),
      (this.$u = new T()),
      (this.Fu = null),
      (this.Lu = 50),
      (this.Mu = !1);
  }
  Pu(t, i) {
    return !t && !i && this.Ko.Gh() >= this.Lu;
  }
  xu(t) {
    let s = this.ri.Gl();
    if (t.length > 0) {
      const e = this.wt.getUserId();
      for (const h of t) {
        const t = (!h.userId && !e) || h.userId === e;
        h.type === i.ql && t && (s = !0);
      }
    }
    return s;
  }
  Iu(t = !1, i = !1, s = !0, e, h, n, u = !1, l = !1) {
    s && this.Nu();
    const a = this.u.AE(),
      c = this.u.OE();
    let d = !1;
    const m = (t, i, r = -1) => {
        let u = !1;
        const l = new Date().valueOf();
        D._s(this.u, D.Ps.La, l),
          -1 !== r && i.push(["X-Braze-Req-Tokens-Remaining", r.toString()]),
          C.Gs({
            url: this.baseUrl + "/data/",
            data: t,
            headers: i,
            L: (s) => {
              null != t.respond_with &&
                t.respond_with.triggers &&
                (this.yu = Math.max(this.yu - 1, 0)),
                this.qt.Ks(t, s, i)
                  ? (this.Ko.Os(),
                    this.yt.al(s),
                    (null != t.respond_with &&
                      t.respond_with.user_id != this.wt.getUserId()) ||
                      (null != t.device && this.u.k(o.C.Fa, t.device),
                      null != t.sdk_metadata &&
                        (this.u.k(o.C.Jh, t.sdk_metadata),
                        this.u.k(o.C.Qh, this.ri.Si())),
                      this.wu(s),
                      D.Qs(this.u, D.Ps.La, 1),
                      "function" == typeof e && e()))
                  : s.auth_error && (u = !0);
            },
            error: () => {
              null != t.respond_with &&
                t.respond_with.triggers &&
                (this.yu = Math.max(this.yu - 1, 0)),
                this.qt.Zh(t.events, t.attributes),
                "function" == typeof h && h();
            },
            Ws: (t) => {
              if (("function" == typeof n && n(t), s && !d)) {
                if (t && !u) this.Ou();
                else {
                  D.Ys(this.u, D.Ps.La);
                  let t = this.ju;
                  (null == t || t < 1e3 * this.fE) && (t = 1e3 * this.fE),
                    this.Ou(Math.min(3e5, U(1e3 * this.fE, 3 * t)));
                }
                d = !0;
              }
            },
          });
      },
      f = this.xu(a),
      g = i || f;
    if (this.Pu(u, f))
      return void r.info(
        "Declining to flush data due to 50 consecutive authentication failures",
      );
    if (s && !this.qt.Xa(a, c, t, g))
      return this.Ou(), void ("function" == typeof n && n(!0));
    const v = this.qt.$a(t, g, a, c, l);
    g && this.yu++;
    let p = !1;
    if (v)
      for (const t of v)
        this.qt.Xs(
          t.requestData,
          (i) => m(t.requestData, t.headers, i),
          D.Ps.La,
          h,
        ),
          (p = !0);
    this.Ko.Fh() && s && !p
      ? this.Ou()
      : f && (r.info("Invoking new session subscriptions"), this.$u.Dt());
  }
  zu() {
    return this.yu > 0;
  }
  Ou(t = 1e3 * this.fE) {
    this.Mu ||
      (this.Nu(),
      (this.Fu = window.setTimeout(() => {
        if (document.hidden) {
          const t = "visibilitychange",
            i = () => {
              document.hidden ||
                (document.removeEventListener(t, i, !1), this.Iu());
            };
          document.addEventListener(t, i, !1);
        } else this.Iu();
      }, t)),
      (this.ju = t));
  }
  Nu() {
    null != this.Fu && (clearTimeout(this.Fu), (this.Fu = null));
  }
  initialize() {
    (this.Mu = !1), this.Ou();
  }
  destroy() {
    this.$u.removeAllSubscriptions(),
      this.Ko.yh(),
      this.Nu(),
      (this.Mu = !0),
      this.Iu(void 0, void 0, !1, void 0, void 0, void 0, void 0, !0),
      (this.Fu = null);
  }
  mr(t) {
    return this.$u.It(t);
  }
  openSession() {
    const t = this.ri.Si() !== this.ri.xo();
    t && (this.u.cE(o.iu.Uo), this.u.cE(o.iu.su)),
      this.Iu(void 0, !1, void 0, () => {
        this.u.ti(o.C.vi);
      }),
      this.Mn(),
      t &&
        import("./Push/push-manager-factory.js").then((t) => {
          if (this.Mu) return;
          const i = t.default.m();
          if (
            null != i &&
            (yt.isPushPermissionGranted() || yt.isPushBlocked())
          ) {
            const t = () => {
                i.mn()
                  ? r.info(
                      "Push token maintenance is disabled, not refreshing token for backend.",
                    )
                  : i.subscribe();
              },
              s = (i, s) => {
                s && t();
              },
              e = () => {
                const i = this.u.j(o.C.In);
                (null == i || i) && t();
              },
              h = A.Yt.Qt;
            new A(h, r).jr(h.ss.cu, s, e);
          }
        });
  }
  Uu() {
    this.u.ti(o.C.gi), this.u.ti(o.C.ws), this.u.ti(o.C.Nr);
  }
  changeUser(t, i, s) {
    const e = this.wt.getUserId();
    if (e !== t) {
      this.ri.yl(),
        this.Uu(),
        null != e && this.Iu(void 0, !1, void 0, void 0, void 0),
        this.wt.ou(t),
        s ? this.Ko.setSdkAuthenticationSignature(s) : this.Ko.xh();
      for (let t = 0; t < i.length; t++) i[t].changeUser(null == e);
      null != e && this.u.ti(o.C.J),
        this.u.ti(o.C.Fa),
        this.u.ti(o.C.nE),
        this.u.ti(o.C._E),
        this.openSession(),
        r.info('Changed user to "' + t + '".');
    } else {
      let i = "Doing nothing.";
      s &&
        this.Ko.kh() !== s &&
        (this.Ko.setSdkAuthenticationSignature(s),
        (i = "Updated SDK authentication signature")),
        r.info(`Current user is already ${t}. ${i}`);
    }
  }
  requestImmediateDataFlush(t) {
    this.Nu(), this.ri.xo();
    this.Iu(
      void 0,
      void 0,
      void 0,
      void 0,
      () => {
        r.error("Failed to flush data, request will be retried automatically.");
      },
      t,
      !0,
    );
  }
  requestFeedRefresh() {
    this.ri.xo(), this.Iu(!0);
  }
  $r(t, i) {
    this.ri.xo(),
      r.info("Requesting explicit trigger refresh."),
      this.Iu(void 0, !0, void 0, t, i);
  }
  Cn(t, e) {
    const h = i._u,
      n = { a: t, l: e },
      u = s.q(h, n);
    return (
      u && (r.info(`Logged alias ${t} with label ${e}`), this.u.k(o.C._E, n)), u
    );
  }
  Fn(i, e, h) {
    if (this.yt.hu(e))
      return (
        r.info(`Custom Attribute "${e}" is blocklisted, ignoring.`), new t()
      );
    const o = { key: e, value: h },
      n = s.q(i, o);
    if (n) {
      const t = "object" == typeof h ? JSON.stringify(h, null, 2) : h;
      r.info(`Logged custom attribute: ${e} with value: ${t}`);
    }
    return n;
  }
  setLastKnownLocation(t, e, h, o, n, u) {
    const l = { latitude: e, longitude: h };
    null != o && (l.altitude = o),
      null != n && (l.ll_accuracy = n),
      null != u && (l.alt_accuracy = u);
    const a = s.q(i.Bu, l, t || void 0);
    return (
      a &&
        r.info(`Set user last known location as ${JSON.stringify(l, null, 2)}`),
      a
    );
  }
  kr(t, s) {
    const e = this.ri.xo();
    return new ve(this.wt.getUserId(), i.Eu, t, e, { cid: s });
  }
  Ju(t, i) {
    return new A(t, i);
  }
  Mn() {
    const t = A.Yt.Qt;
    this.Ju(t, r).setItem(t.ss.La, 1, {
      baseUrl: this.baseUrl,
      data: { api_key: this.rn, device_id: this.on.ce().id },
      userId: this.wt.getUserId(),
      sdkAuthEnabled: this.Ko.Fh(),
    });
  }
  yr(t) {
    for (const i of t)
      if (i.api_key === this.rn) this.qt.Zh(i.events, i.attributes);
      else {
        const t = A.Yt.Qt;
        new A(t, r).setItem(t.ss.wr, p.W(), i);
      }
  }
  Gn(e, h, o) {
    if (this.yt.hu(e))
      return (
        r.info(`Custom Attribute "${e}" is blocklisted, ignoring.`), new t()
      );
    let n, u;
    return (
      null === h && null === o
        ? ((n = i.Ku), (u = { key: e }))
        : ((n = i.Wu), (u = { key: e, latitude: h, longitude: o })),
      s.q(n, u)
    );
  }
  Hn(t, e) {
    const h = { group_id: t, status: e };
    return s.q(i.Gu, h);
  }
}
